import {
  VALIDATION_ERROR_HTTP_CODE,
  UNAUTHORIZED_ERROR_HTTP_CODE,
  TOO_MANY_REQUESTS_HTTP_CODE,
  MENSAJE_ERROR_PERMISO,
  WarningException,
  ErrorException,
  ConfirmException,
  UnauthorizeException,
  BAD_GATEWAY_ERROR_HTTP_CODE,
  NoConnectionException,
} from "utils";

export const ResponseExceptionHandlerHelper = () =>
  (() => {
    function isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }

    const handleException = (response) => {
      var isJson = isJsonString(response.Data.Message);
      if (response.StatusCode == VALIDATION_ERROR_HTTP_CODE && !isJson) {
        throw new WarningException(response.Data.Message);
      } else if (response.StatusCode == VALIDATION_ERROR_HTTP_CODE && isJson) {
        throw new ConfirmException(response.Data.Message);
      } else if (response.StatusCode == UNAUTHORIZED_ERROR_HTTP_CODE) {
        throw new UnauthorizeException(response.Data);
      } else if (response.StatusCode == TOO_MANY_REQUESTS_HTTP_CODE) {
        throw new WarningException(response.Data.Message);
      } else if (response.StatusCode == BAD_GATEWAY_ERROR_HTTP_CODE) {
        throw new NoConnectionException(response.Data.Message);
      } else {
        throw new ErrorException(
          response.Data.Message,
          response.Data.ExceptionType,
          response.Data.ExceptionMessage,
          response.Data.StackTrace
        );
      }
    };
    return {
      handleException,
    };
  })();
